import { render, staticRenderFns } from "./AddonDialog.vue?vue&type=template&id=08266004&"
import script from "./AddonDialog.vue?vue&type=script&lang=js&"
export * from "./AddonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports